import { translate } from '@/domains/core/localization/translate';
export default translate({
  "label": "Deals",
  "close": "Close"
});